import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { apiGet } from "@/shop/api";
import ProductCard from "@/components/shop/ProductCard";

export default function HomeShopModules() {
  const [selected, setSelected] = useState([]);
  const [archive, setArchive] = useState([]);

  useEffect(() => {
    apiGet("/api/shop/products?featured_home=true&limit=4")
      .then((d) => setSelected(Array.isArray(d) ? d.slice(0, 4) : []))
      .catch(() => setSelected([]));
    apiGet("/api/shop/products?product_type=archive&sort=newest&limit=3")
      .then((d) => setArchive(Array.isArray(d) ? d.slice(0, 3) : []))
      .catch(() => setArchive([]));
  }, []);

  if (selected.length === 0 && archive.length === 0) return null;

  return (
    <>
      {selected.length > 0 && (
        <section data-testid="home-selected-objects" className="bg-ink border-t border-ink-border px-5 md:px-10 py-20 md:py-28">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
            <div>
              <p className="font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-ember mb-4">
                Selected objects
              </p>
              <h2 className="font-serif font-light text-3xl md:text-5xl tracking-tight">
                Scelti dalla <span className="italic text-ember">redazione</span>
              </h2>
            </div>
            <Link
              to="/shop"
              data-testid="home-shop-cta"
              className="group inline-flex items-center gap-3 w-fit font-mono text-[11px] uppercase tracking-[0.25em] border border-bone/30 rounded-full px-6 py-3 hover:border-ember hover:text-ember transition-colors duration-300"
            >
              Visita lo Shop
              <ArrowUpRight size={15} strokeWidth={1.5} className="transition-transform duration-300 group-hover:rotate-45" />
            </Link>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-7">
            {selected.map((p, i) => (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.8, delay: (i % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
              >
                <ProductCard p={p} />
              </motion.div>
            ))}
          </div>
        </section>
      )}

      {archive.length > 0 && (
        <section data-testid="home-latest-archive" className="bg-ink-surface border-t border-ink-border px-5 md:px-10 py-20 md:py-28">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
            <div>
              <p className="font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-ember mb-4">
                Latest from the archive
              </p>
              <h2 className="font-serif font-light text-3xl md:text-5xl tracking-tight">
                Ultimo dall'<span className="italic text-ember">Archivio</span>
              </h2>
            </div>
            <Link
              to="/shop/archive"
              data-testid="home-archive-cta"
              className="group inline-flex items-center gap-3 w-fit font-mono text-[11px] uppercase tracking-[0.25em] border border-bone/30 rounded-full px-6 py-3 hover:border-ember hover:text-ember transition-colors duration-300"
            >
              Entra nell'Archivio
              <ArrowUpRight size={15} strokeWidth={1.5} className="transition-transform duration-300 group-hover:rotate-45" />
            </Link>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-7">
            {archive.map((p, i) => (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.8, delay: (i % 3) * 0.07, ease: [0.16, 1, 0.3, 1] }}
              >
                <ProductCard p={p} />
              </motion.div>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
